import React from "react";
import useUserStore from "../store/userStore"; // Update this path according to your store location
import {
  BottomNavigation,
  BottomNavigationAction,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import getAvatarUrl from "../utils/dicebear";

import Box from "@mui/material/Box";
import { IoChatbubblesOutline } from "react-icons/io5";
import { CiSquarePlus } from "react-icons/ci";
import { GoHome } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { ProfilePicture } from "./CommonComponents";
import logo from "../assets/logo.png"; // Add this import

export function NavBottom() {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const { userData } = useUserStore();

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        left: 0,
        zIndex: 1000,
        borderTop: "2px solid #e0e0e0",
        backgroundColor: "#f9f9f9",
        display: { xs: "block", lg: "none" }, // Hide on large screens
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction
          icon={<GoHome size={30} />}
          onClick={() => {
            navigate("/social");
          }}
        />
        <BottomNavigationAction
          icon={<CiSquarePlus size={30} />}
          onClick={() => {
            navigate("/newPost");
          }}
        />
        <BottomNavigationAction
          icon={<IoChatbubblesOutline size={30} />}
          onClick={() => {
            navigate("/chats");
          }}
        />
        <BottomNavigationAction
          onClick={() => {
            navigate("/profile");
          }}
          icon={
            <ProfilePicture
              src={getAvatarUrl(userData?.name)}
              styles={"rounded-full"}
              size={30}
            />
          }
        />
      </BottomNavigation>
    </Box>
  );
}

export function SideDrawer() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate(); // Add navigation
  const { userData } = useUserStore();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(open);
  };

  const list = () => (
    <Box
      sx={{
        width: 250,
        height: "100%",
        borderRight: "1px solid #e0e0e0",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <div className="p-2 border-b border-gray-200">
        <img src={logo} alt="Logo" className="h-20 w-20" />
      </div>
      <List>
        <ListItem
          className="cursor-pointer"
          button
          onClick={() => navigate("/social")}
        >
          <ListItemIcon>
            <GoHome size={30} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem
          className="cursor-pointer"
          button
          onClick={() => navigate("/newPost")}
        >
          <ListItemIcon>
            <CiSquarePlus size={30} />
          </ListItemIcon>
          <ListItemText primary="Add" />
        </ListItem>
        <ListItem
          className="cursor-pointer"
          button
          onClick={() => navigate("/chats")}
        >
          <ListItemIcon>
            <IoChatbubblesOutline size={30} />
          </ListItemIcon>
          <ListItemText primary="Messages" />
        </ListItem>
        <ListItem
          className="cursor-pointer"
          button
          onClick={() => navigate("/profile")}
        >
          <ListItemIcon>
            <ProfilePicture
              src={getAvatarUrl(userData?.name)}
              styles={"rounded-full"}
              size={30}
            />
          </ListItemIcon>
          <ListItemText primary="Profile" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: { xs: "none", lg: "block" } }}>
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          "& .MuiDrawer-paper": {
            marginTop: "0", // Changed from 64px to 0
            boxSizing: "border-box",
          },
        }}
      >
        {list()}
      </Drawer>
    </Box>
  );
}
